/** Query params for GET /tasks. Backend expects these exact relation indexes. */
export const TASK_RELATIONS = {
  "relations[0]": "author",
  "relations[2]": "status",
  "relations[3]": "parent",
  "relations[4]": "responsible",
  "relations[5]": "lead",
  "relations[6]": "service",
};

export const buildTaskRelationParams = () => ({ ...TASK_RELATIONS });

export const PRIORITY_OPTIONS = ["low", "medium", "high"];

export const formatTaskDeadlineForInput = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value).replace(" ", "T").slice(0, 16);
  }
  const pad = (n) => String(n).padStart(2, "0");
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const formatTaskDeadlineForApi = (value) => {
  if (!value) return "";
  const normalized = String(value).trim().replace("T", " ");
  return normalized.length === 16 ? `${normalized}:00` : normalized;
};

export const userLabel = (user) =>
  user?.name ??
  user?.username ??
  user?.email ??
  (user?.id ? String(user.id) : "");

export const leadLabel = (lead) =>
  lead?.name ??
  lead?.dba_name ??
  lead?.email ??
  lead?.phone ??
  (lead?.id ? String(lead.id) : "");

export const serviceLabel = (service) =>
  service?.name ?? (service?.id ? String(service.id) : "");

/** API values like `in_progress` → `In Progress` for list/filter UI. */
export const formatTaskStatusLabel = (value) => {
  const raw = String(value ?? "").trim();
  if (!raw) return "";
  return raw
    .replace(/_/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const taskStatusLabel = (status) =>
  formatTaskStatusLabel(
    status?.label ??
      status?.name ??
      status?.title ??
      (status?.id != null ? String(status.id) : ""),
  );

/** Status label on list rows when relation is nested or only flat fields exist */
export const resolveTaskRowStatusLabel = (row) => {
  if (!row) return "";
  const nested = row.status;
  return (
    taskStatusLabel(nested) ||
    formatTaskStatusLabel(row.status_name) ||
    formatTaskStatusLabel(row.status_label) ||
    ""
  );
};

export const formatTaskListDateTime = (value) => {
  if (!value) return "—";
  const d = new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(d.getTime()))
    return String(value).replace("T", " ").slice(0, 16);
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
